export namespace SwitchOrganizationModels {
  export enum Tab {
    MyOrganizations = 'MyOrganizations',
    Support = 'Support',
  }
}
